export function shouldIncludeAddressPart(value) {
  if (value === null || value === undefined) return false;
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return false;
    if (trimmed.toLowerCase() === "none") return false;
  }
  return true;
}

function joinCommaSeparatedParts(partList) {
  const included = partList.filter(shouldIncludeAddressPart);
  return included.length ? included.join(", ") : "-";
}

export function formatPunchOrderAddress(address) {
  if (!address || typeof address !== "object") return "-";
  return joinCommaSeparatedParts([
    address.recipientName,
    address.parentName,
    address.recipientPhoneNumber ?? address.maskedPhoneNo,
    address.recipientEmail,
    address.addressLine1,
    address.addressLine2,
    address.street,
    address.city,
    address.district,
    address.state,
    address.pincode ?? address.postalCode,
    address.country,
  ]);
}

function postalCodeDisplayFromRecord(addressRecord) {
  const postalCodeRaw = addressRecord?.postal_code ?? addressRecord?.postalCode;
  if (postalCodeRaw == null || postalCodeRaw === "") return undefined;
  if (typeof postalCodeRaw === "object") {
    return (
      postalCodeRaw.name ??
      postalCodeRaw.code ??
      postalCodeRaw.postal_code ??
      ""
    );
  }
  return String(postalCodeRaw);
}

function districtDisplayFromRecord(addressRecord) {
  const districtValue = addressRecord?.district;
  if (districtValue == null || districtValue === "") return undefined;
  if (typeof districtValue === "object") return districtValue.name ?? "";
  return String(districtValue);
}

function stateDisplayFromRecord(addressRecord) {
  const stateValue = addressRecord?.state;
  if (stateValue == null || stateValue === "") return undefined;
  if (typeof stateValue === "object") return stateValue.name ?? "";
  return String(stateValue);
}

export function formatOrderServiceAddress(addressRecord) {
  if (!addressRecord || typeof addressRecord !== "object") return "-";
  return joinCommaSeparatedParts([
    addressRecord.recipient_name ?? addressRecord.recipientName,
    addressRecord.parent_name ?? addressRecord.parentName,
    addressRecord.recipient_phone_number ??
      addressRecord.masked_phone_no ??
      addressRecord.recipientPhoneNumber,
    addressRecord.email ??
      addressRecord.recipient_email ??
      addressRecord.recipientEmail,
    addressRecord.address_line_1 ?? addressRecord.addressLine1,
    addressRecord.address_line_2 ?? addressRecord.addressLine2,
    addressRecord.street,
    addressRecord.city,
    districtDisplayFromRecord(addressRecord),
    stateDisplayFromRecord(addressRecord),
    postalCodeDisplayFromRecord(addressRecord),
    addressRecord.country,
  ]);
}

export function formatOrderServiceAddressWithoutContact(addressRecord) {
  if (!addressRecord || typeof addressRecord !== "object") return "-";
  return joinCommaSeparatedParts([
    addressRecord.address_line_1 ?? addressRecord.addressLine1,
    addressRecord.address_line_2 ?? addressRecord.addressLine2,
    addressRecord.street,
    addressRecord.city,
    districtDisplayFromRecord(addressRecord),
    stateDisplayFromRecord(addressRecord),
    postalCodeDisplayFromRecord(addressRecord),
    addressRecord.country,
  ]);
}

export function recipientNameFromOrderAddress(addressRecord) {
  if (!addressRecord || typeof addressRecord !== "object") return "-";
  const name =
    addressRecord.recipient_name ?? addressRecord.recipientName ?? "";
  return shouldIncludeAddressPart(name) ? name : "-";
}
